// extracted by mini-css-extract-plugin
export default {"root":"QRCodeViewSorting_root__uZDMR","icon":"QRCodeViewSorting_icon__QWtPK"};